module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Új jelszó igénylés")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\t\tEzen a felületen új jelszót állíthat be a fiókjára. Ha mégsem szeretné megváltoztatni a jelszavát, hagyja figyelmen kívül."), _c('br'), _vm._v(" "), _c('b', [_vm._v("A jelszónak legalább 8 karakter hosszú szöveget kell megadni, legalább egy kis és nagybetű, valamint szám használatával!")]), _vm._v(" "), _c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Új jelszó")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Küldés")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ce12f38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordResetView.vue
// module id = 413
// module chunks = 2